import Vue from 'vue';
import client from '@/apis/client';

const localize = (item, key) => {
  const locale = Vue.$cookies.get('locale') || 'th_TH';

  if (locale === 'en_US' && item[`${key}_en`]) {
    return item[`${key}_en`];
  }

  return item[key];
};

export const createDistribution = async (body) => {
  const { data } = await client.post('/distributions', body);

  return data;
};

export const updateDistribution = async (id, body) => {
  const { data } = await client.put(`/distributions/${id}`, body);

  return data;
};

export const removeDistribution = async (id) => {
  const { data } = await client.delete(`/distributions/${id}`);

  return data;
};

export const getDistributions = async (page, size, productId) => {
  const params = {};

  if (productId) {
    params.product_id = productId;
  }

  if (page) {
    params.current_page = page;
  }

  if (size) {
    params.page_size = size;
  }

  const { data: { data: items, total } } = await client.get('/distributions', { params });
  const offset = (page - 1) * size;
  const distributions = items.map((item, index) => (
    {
      ...item,
      no: offset + (index + 1),
      location_name_localized: localize(item, 'location_name'),
    }
  ));

  return { distributions, total };
};

export const getDistribution = async (distributionId) => {
  if (!distributionId) {
    return null;
  }

  let { data: { data } } = await client.get(`/distributions/${distributionId}`);

  if (typeof data === 'object') {
    data = {
      ...data,
      location_name_localized: localize(data, 'location_name'),
    };
  }

  return data;
};
